import { ContactSearchFieldEnum } from 'modules/contacts/enums/contact-enum'
import {
  ContactFieldApiInterface,
  ContactFilterType,
} from 'modules/contacts/types/contact-filter-interface'
import { getCustomDefaultFilters } from 'modules/contacts/utils/get-custom-default-filters'
import { getDefaultFilterValue } from 'modules/contacts/utils/get-default-filter-value'

export const getEmptyFilter = (filterFields?: ContactFieldApiInterface) => {
  const additionalEmptyFilter: ContactFilterType = Object.values(ContactSearchFieldEnum).reduce(
    (obj, el) => ({ ...obj, [el]: getDefaultFilterValue(el) }),
    {},
  )
  if (filterFields) {
    return { ...getCustomDefaultFilters(filterFields.items), ...additionalEmptyFilter }
  } else {
    return { ...additionalEmptyFilter }
  }
}
